import { create } from 'zustand';

import { TextToStructuredObservation } from '@/api';

import { HighlightedFindingState } from './use-highlighted-finding.model';

export const useHighlightedFindingStore = create<HighlightedFindingState>((set) => ({
  clearHighlightedFinding: () => {
    set({ highlightedFinding: null });
  },
  highlightedFinding: null,
  setHighlightedFinding: (finding: TextToStructuredObservation) => {
    set({ highlightedFinding: finding });
  },
}));
